<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition">
    <v-card class="v-em">
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>{{ readonly ? "查看员工信息":"填写员工信息"}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container>
        <v-layout v-if="!readonly" justify-end>
          <v-btn :href="templateUrl" color="primary" flat>下载模板</v-btn>
          <CUpload
            :show="false"
            :on-success="onUploadSuccess"
            :on-error="onUploadError"
            :limit="1"
            :asyncData="asyncData"
            action="/app/api/heshunbao/b/groupEmployeeInfo"
            accept=".xlsx, .xls"
          >批量上传</CUpload>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form ref="form" lazy-validation>
              <v-data-table v-if="isErr" :headers="headers" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <p>{{props.item.name}}</p>
                    </td>
                    <td>
                      <p>{{props.item.idNumber}}</p>
                    </td>
                    <td>
                      <p>{{props.item.idType}}</p>
                    </td>
                    <td>
                      <p>{{props.item.errMsg}}</p>
                    </td>
                  </tr>

                </template>
              </v-data-table>
              <v-data-table v-if="!isErr" :headers="newheaders" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <p>{{props.item.name}}</p>
                    </td>
                    <td>
                      <p>{{props.item.idCard}}</p>
                    </td>
                    <td>
                      <p>{{props.item.category.name}}</p>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4" v-if="!isErr">
          <v-flex>
            <strong>
              员工总数：
              <em class="em">{{ employees.length }}</em> 人
            </strong>
            <span>（1类职业 {{ oc1Count }} 人，2类职业 {{ oc2Count }} 人，3类职业 {{ oc3Count }} 人，4类职业 {{ oc4Count }} 人，5类职业{{oc5Count }} 人，6类职业 {{ oc6Count }} 人）
            </span>
          </v-flex>
          <v-flex shrink>
            <v-btn v-if="!readonly" color="primary" @click="confirm" block>确定</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import JobCategory from "@/components/Order/JobCategory";
import validate from "@/assets/js/validate";
import dateUtil from "@/assets/js/utils/date";
export default {
  components: {
    JobCategory
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    effectBeginDate:String
  },
  data() {
    return {
      isErr:false,
      templateUrl:
        "http://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9B%E5%A2%9E%E5%91%98excel%E6%A8%A1%E6%9D%BF.xlsx",
      headers: [
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "身份证号",
          value: "idNumber",
          sortable: false
        },
        {
          text: "证件类型",
          value: "idType",
          sortable: false
        },
        {
          text: "错误信息",
          align: "errMsg",
          sortable: false
        }
      ],
      newheaders: [
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "身份证号",
          value: "idCard",
          sortable: false
        },
        {
          text: "职业类别",
          value: "category",
          sortable: false
        },
      ],
      items: [],
      editObjTemplate: {
        _isEdit: true,
        _status: 0, // 0 还未添加，1：已添加未保存，2：已保存
        name: "",
        idCard: "",
        phone: "",
        category: {
          code: "",
          name: "",
          level: 0
        }
      },
      rules: {
        name: [
          v => {
            if (!v) {
              return "请输入姓名";
            }
            if (!validate.isChineseName(v)) {
              return "姓名格式错误，请重新输入";
            }
            return true;
          }
        ],
        idCard: [
          v => {
            if (!v) {
              return "请输入身份证号";
            }
            if (!validate.isIDCard(v)) {
              return "请输入正确的身份证号";
            }
            if (
              this.items.findIndex(item => !item._isEdit && item.idCard === v) >
              -1
            ) {
              return "身份证号重复，请重新输入";
            }
            const birthday = dateUtil.getBirthdayByID(v);
            const age = dateUtil.getAge(birthday);
            if (age < 16 || age > 65) {
              return "年龄未在承保范围（16周岁 - 65周岁）";
            }
            return true;
          }
        ],
        phone: [
          v => {
            if (!v) {
              return "请输入手机号";
            }
            if (!validate.isMobilePhone(v)) {
              return "手机号格式错误，请重新输入";
            }
            return true;
          }
        ],
        category: [
          v => {
            if (!v) {
              return "请选择职业类别";
            }
            const codes = this.items.map(item => item.category.code);
            const count = Array.from(new Set(codes)).length;
            if (count > 17) {
              return "单次投保中最多支持17种不同的职业，如超过请分开投保";
            }
            return true;
          }
        ]
      },
      asyncData:{
        startDate: this.effectBeginDate
      },
      resultData:{},
    };
  },
  computed: {
    dialog: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      }
    },
    employees() {
      return this.items.filter(item => item._status !== 0);
    },
    oc1Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 1).length;
      }
      return 0;
    },
    oc2Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 2).length;
      }
      return 0;
    },
    oc3Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 3).length;
      }
      return 0;
    },
    oc4Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 4).length;
      }
      return 0;
    },
    oc5Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 5).length;
      }
      return 0;
    },
    oc6Count() {
      if(!this.isErr){
        return this.employees.filter(item => item.category.level === 6).length;
      }
      return 0;
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.items = this.value.map(item => item);
        if (!this.readonly) {
          this.addEditItem();
        }
      }
    },
    effectBeginDate(effectBeginDate){
      this.asyncData.startDate = effectBeginDate;
    }
  },
  created() {
    if (this.readonly) {
      this.headers.pop();
    }
  },
  methods: {
    addEditItem() {
      // const editItem = Object.assign({}, this.editObjTemplate);
      // this.items.unshift(editItem);
    },
    categorySelected(index, selected) {
      this.items[index].categoryCode = selected.code;
      this.items[index].categoryLevel = selected.level;
      this.items[index].category = selected.name;
    },
    onUploadSuccess(res) {
      const arr = []
      if(res.data.errDetails){
        this.isErr = true
        res.data.errDetails.forEach(element => {
          arr.push({
            name: element.name,
            idNumber: element.idNumber,
            idType: element.idType,
            errMsg: element.errMsg,
          });
        });
        this.items = arr
      }else{
        console.log(this.isErr)
        this.isErr = false;
        this.resultData = res.data;
        res.data.data.forEach(element => {
          arr.push({
            name: element.name,
            idCard: element.idNumber,
            category: {
              code: element.professionCode,
              name: element.professionName,
              level: element.professionLevel,
              planId:element.planId,
              planName:element.planName,
            }
          });
        });
        this.items = arr
      }
    },
    onUploadError(err) {
      // this.$message.error(err.message);
      let error = err.message.replace(/;/g, "<br>");
      // if(error.code != 1003){
      //   return
      // }
      const message =
        "您导入的员工信息中有格式错误，请修改后重新上传，具体错误信息如下所示：<br>" +
        error;
      this.$messageBox.alert({
        message,
        width: 500
      });
    },
    confirm() {
      if (this.employees.length < 3) {
        this.$message.error("员工人数需达3人，请继续补充人数");
        return false;
      }
      // if (this.oc4Count / this.employees.length > 0.8) {
      //   this.$message.error("4类职业人员在总人数中占比不能超过80%");
      //   return false;
      // }
      // if (this.oc5Count / this.employees.length > 0.5) {
      //   this.$message.error("5类职业人员在总人数中占比不能超过50%");
      //   return false;
      // }
      // if (this.oc3Count === 0) {
      //   this.$message.error("4-5类职业不能单独承保");
      //   return false;
      // }
      this.dialog = false;
      this.$emit("input", this.employees);
      this.$emit("warningData", this.resultData);
    }
  }
};
</script>

<style lang="scss">
.v-em {
  .operation-btn {
    min-width: auto;
    margin: 6px 0;
  }
  .employee-table {
    .v-table__overflow {
      max-height: 700px;
      overflow: auto;
    }
  }
}
</style>

